var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { PermissionType } from '@synisys/idm-authorization-client-js';
import { DePermissionService, } from '@synisys/idm-de-service-client-js';
import { FormService, FormType, } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService, MetaFieldType, } from '@synisys/idm-kb-service-client-js';
import { LanguageService } from '@synisys/idm-message-language-service-client-js';
import { ValidationService } from '@synisys/idm-validation-calculation-service-client-js';
import { ProcessService, } from '@synisys/idm-workflow-service-client-js';
import { isEmpty, isNil } from 'lodash';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { of } from 'rxjs/observable/of';
import { zip } from 'rxjs/observable/zip';
import { first, map, switchMap } from 'rxjs/operators';
import { MetaFormModel } from '../model';
import { combineLatest } from 'rxjs/observable/combineLatest';
var MetaFormHelperService = /** @class */ (function () {
    function MetaFormHelperService(_validationService, _languageService, _dePermissionService, _kbService, _formService, _processService) {
        this._validationService = _validationService;
        this._languageService = _languageService;
        this._dePermissionService = _dePermissionService;
        this._kbService = _kbService;
        this._formService = _formService;
        this._processService = _processService;
    }
    MetaFormHelperService.prototype.loadFormMetaModel = function (categoryName, entity, formName, formId, isWithPermission, wfStateId) {
        var _this = this;
        return this._kbService.getMetaFields(categoryName).pipe(switchMap(function (metaFields) {
            var wfStateMetaField;
            if (isNil(wfStateId)) {
                wfStateMetaField = metaFields.find(function (field) {
                    return field.getType() === MetaFieldType.WORKFLOW_STATE;
                });
            }
            return zip(_this.loadRequiredMetaFieldIds(categoryName, entity, wfStateMetaField, wfStateId), _this._languageService.getInputLanguages(), _this._formService.loadForm(formName, formId, categoryName), isWithPermission
                ? _this.loadDePermissions(categoryName, entity)
                : of(undefined), of(metaFields), _this.obtainChildClassifiers(metaFields));
        }), map(function (data) {
            var wfStateMetaField = data[4].find(function (field) {
                return (field.getType() === MetaFieldType.WORKFLOW_STATE);
            });
            return new MetaFormModel(data[2].model, data[0], data[4], data[1], wfStateMetaField, data[2].type, formId, data[3], data[5]);
        }));
    };
    MetaFormHelperService.prototype.updateRequiredFields = function (metaForm, entity) {
        return this.loadRequiredMetaFieldIds(metaForm.layoutModel.category, entity, metaForm.wfStateMetaField).pipe(map(function (requiredFields) {
            metaForm.requiredMetaFieldIds = requiredFields;
            return true;
        }));
    };
    MetaFormHelperService.prototype.updateDePermissions = function (metaForm, entity) {
        return this.loadDePermissions(metaForm.layoutModel.category, entity).pipe(map(function (dePermission) {
            metaForm.dePermission = dePermission;
            return true;
        }));
    };
    MetaFormHelperService.prototype.hasPermissionFor = function (metaForm, permissionType, isInDrawer) {
        if (permissionType === PermissionType.EDIT &&
            metaForm.formType === FormType.VIEW &&
            isInDrawer) {
            return false;
        }
        else {
            switch (permissionType) {
                case PermissionType.ADD:
                    return metaForm.dePermission.canCreate;
                case PermissionType.VIEW:
                    return metaForm.dePermission.canView;
                case PermissionType.EDIT:
                    return metaForm.dePermission.canEdit;
                case PermissionType.DELETE:
                    return metaForm.dePermission.canDelete;
            }
        }
    };
    MetaFormHelperService.prototype.obtainChildClassifiers = function (allMetaFields) {
        var _this = this;
        var classifiers = allMetaFields.filter(function (field) { return field.getType() === MetaFieldType.CLASSIFIER; });
        if (!isEmpty(classifiers)) {
            var $classes = classifiers.map(function (classifier) {
                return _this._kbService
                    .getMetaFields(classifier.getCompoundCategorySystemName())
                    .pipe(map(function (classifierFields) {
                    return {
                        classifierFields: classifierFields,
                        category: classifier.getCompoundCategorySystemName(),
                        field: classifier,
                    };
                }));
            });
            return combineLatest($classes).pipe(first(), map(function (data) {
                var itemsWithParent = data.filter(function (item) {
                    return item.classifierFields.some(function (field) {
                        return field.getType() === MetaFieldType.PARENT;
                    });
                });
                return itemsWithParent
                    .map(function (itemWithParent) {
                    var parent = itemWithParent.classifierFields.find(function (field) {
                        return field.getType() === MetaFieldType.PARENT;
                    });
                    if (!isNil(parent)) {
                        var parentCategory_1 = parent.getCompoundCategorySystemName();
                        var parentItem = data.find(function (item) { return parentCategory_1 === item.category; });
                        return !isNil(parentItem)
                            ? {
                                parent: parentItem.field,
                                child: itemWithParent.field,
                            }
                            : undefined;
                    }
                })
                    .filter(function (item) { return !isNil(item); });
            }));
        }
        return of([]);
    };
    MetaFormHelperService.prototype.loadDePermissions = function (categoryName, entity) {
        return this._dePermissionService.getCategoryDePermissionsByInstance(categoryName, !isNil(entity.getInstanceId()) ? entity.getInstanceId() : -1);
    };
    MetaFormHelperService.prototype.loadRequiredMetaFieldIds = function (categoryName, entity, wfStateMetaField, wfStateId) {
        var _this = this;
        if (!isNil(wfStateId)) {
            return this._validationService.getCategoryRequiredMetaFieldIds(categoryName, wfStateId);
        }
        if (isNil(wfStateMetaField)) {
            return this._validationService.getCategoryRequiredMetaFieldIds(categoryName);
        }
        var wfState = entity.getProperty(wfStateMetaField.getSystemName());
        if (isNil(wfState.value)) {
            return fromPromise(this._processService.getProcesses()).pipe(switchMap(function (processes) {
                var categoryProcess = processes.find(function (process) {
                    return process.getCategorySystemName() === categoryName;
                });
                return categoryProcess
                    ? _this._validationService.getCategoryRequiredMetaFieldIds(categoryName, categoryProcess.getInitialStateId())
                    : _this._validationService.getCategoryRequiredMetaFieldIds(categoryName);
            }));
        }
        else {
            return this._validationService.getCategoryRequiredMetaFieldIds(categoryName, wfState.value.getId());
        }
    };
    MetaFormHelperService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ValidationService,
            LanguageService,
            DePermissionService,
            KbService,
            FormService,
            ProcessService])
    ], MetaFormHelperService);
    return MetaFormHelperService;
}());
export { MetaFormHelperService };
//# sourceMappingURL=meta-form-helper.service.js.map